import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicComponentsModule } from '../../modules/dynamic-components/dynamic-components/dynamic-components.module';
import { AccordionsGroupModule } from '../accordions-group/accordions-group.module';
import { PureHtmlComponentModule } from '../pure-html/pure-html.module';
import { InfoBoxComponent } from './info-box.component';


@NgModule({
  declarations: [
    InfoBoxComponent
  ],
  imports: [
    CommonModule,
    AccordionsGroupModule,
    TranslateModule,
    DynamicComponentsModule,
    PureHtmlComponentModule
  ],
  exports: [InfoBoxComponent]
})
export class InfoBoxModule { }
